<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="pt-3">Your session has timed out!</h1>
            <p class="text-muted">ログインから一定時間が経過した場合、再ログインが必要となります.</p>
            <font-awesome-icon :icon="['fas', 'arrow-circle-right']"/>&nbsp;<router-link to="/login">ログインページへ</router-link>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: 'PageSessionTimeout',
  methods: {
    ...mapActions('auth', ['logout'])
  },
  async created() {
    // ログアウト処理
    await this.logout()
  }
}
</script>